<template>
  <div class="container table-responsive">
    <table
      id="cart"
      class="table table-hover table-sm"
      style="font-size: 1.2rem"
    >
      <thead>
        <tr>
          <th style="width: 50%">Product</th>
          <th style="width: 10%">Price</th>
          <th style="width: 8%">Quantity</th>
          <th
            style="width: 22%"
            class="text-center"
          >Subtotal</th>
          <th style="width: 10%"></th>
        </tr>
      </thead>

      <transition-group
        name="list-shopping-cart"
        tag="tbody"
      >
        <app-cart-item
          v-for="cartItem in cartItemList"
          :cartItem="cartItem"
          :key="cartItem.id"
        ></app-cart-item>
      </transition-group>

      <tfoot>
        <tr class="d-table-row d-sm-none">
          <td class="text-center">
            <strong>Total Php{{ cartValue }}</strong>
          </td>
        </tr>
        <tr>
          <td>
            <button
              class="btn btn-warning"
              @click="saveShoppingCartLocal"
            >
              <i class="fa fa-angle-left"></i> Save and Continue Shopping
            </button>
          </td>
          <td
            colspan="2"
            class="d-none d-sm-table-cell"
          ></td>
          <td class="d-none d-sm-table-cell text-center">
            <strong>Total Php {{ cartValue.toFixed(2) }}</strong>
          </td>
          <td class="px-0">
            <button
              class="btn custom-button-color"
              @click="checkout"
            >
              <span class="text-nowrap">Checkout <i class="fa fa-angle-right d-inline"></i></span>
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CartItem from "./cart/CartItem.vue";
import { ref } from "../config/firebaseConfig";
import axios from "axios";
import firebase from "firebase";

export default {
  created: function () {},
  computed: {
    ...mapGetters([
      "cartItemList",
      "isLoggedIn",
      "products",
      "currentUser",
      "cartValue",
      "userCredits",
    ]),
  },
  components: {
    appCartItem: CartItem,
  },
  methods: {
    ...mapActions([
      "saveShoppingCart",
      "addMessage",
      "saveToTransaction",
      "clearCart",
      "getSlots",
      "addSlots",
      "updateCredit",
    ]),
    checkValidCart(itemList, prodList) {
      let isValid = true;
      let message = "";

      itemList.map((item) => {
        for (let prodIdx = 0; prodIdx < prodList.length; prodIdx++) {
          if (prodList[prodIdx].id == item.id) {
            if (prodList[prodIdx].quantity < item.quantity) {
              message = `Only ${prodList[prodIdx].quantity} ${item.title} available in stock`;
              isValid = false;
              return;
            }
            break;
          }
        }
      });
      return {
        isValid,
        message,
      };
    },
    saveShoppingCartLocal() {
      if (this.isLoggedIn) {
        let { isValid, message } = this.checkValidCart(
          this.cartItemList,
          this.products
        );

        if (isValid) {
          this.saveShoppingCart({
            cartItemList: this.cartItemList,
            uid: this.currentUser.uid,
          }).then(() => {
            this.addMessage({
              messageClass: "success",
              message: "Your shopping cart is saved successfully",
            });
            this.$router.push("/");
          });
        } else {
          this.addMessage({
            messageClass: "danger",
            message: message,
          });
        }
      } else {
        this.addMessage({
          messageClass: "warning",
          message: "Please login to save your cart",
        });
      }
    },
    console() {
      for (var cart in this.cartItemList) {
        console.log(this.cartItemList[cart].id);
      }
    },

    checkout() {
      if (this.isLoggedIn) {
        if (!this.cartItemList || this.cartItemList.length == 0) {
          this.addMessage({
            messageClass: "warning",
            message: "Your cart is empty!",
          });
          return;
        } else if (this.cartItemList.length > 1) {
          this.$swal({
            icon: "error",
            title: "Checkout 1 item at a time",
            text: "Something went wrong!",
          });
          return;
        }
        let { isValid, message } = this.checkValidCart(
          this.cartItemList,
          this.products
        );
        // console.log("usercredits", this.currentUser.credits);
        // console.log("cartValue", this.cartValue);
        if (this.currentUser.credits < this.cartValue) {
          this.$swal({
            title: "Error!",
            text: "Insufficient Balance. Please Top Up",
            icon: "error",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Top Up",
          }).then((result) => {
            if (result.isCancel) {
              this.$swal({});
            } else if (result.isConfirmed) {
              this.$swal({
                title: "Add Load via GCASH",
                html: `<input type="number" id="amount" class="swal2-input" placeholder="Amount"> <br>
                <input type="text" id="reference" class="swal2-input" placeholder="GCASH Ref. No.">`,
                confirmButtonText: "Add Load",
                focusConfirm: false,
                preConfirm: () => {
                  const amount = this.$swal
                    .getPopup()
                    .querySelector("#amount").value;
                  const reference = this.$swal
                    .getPopup()
                    .querySelector("#reference").value;
                  return { amount: amount, reference: reference };
                },
              }).then((result) => {
                // console.log("amount", result.value.amount);
                // console.log("reference", result.value.reference);
                if (
                  result.value.amount < 0 ||
                  result.value.amount === "" ||
                  result.value.amount == null
                ) {
                  // console.log("hehehehe");
                  this.$swal({
                    icon: "error",
                    title: "Please enter a valid amount you sent",
                  });
                } else if (
                  result.value.reference === "" ||
                  result.value.reference == null
                ) {
                  this.$swal({
                    icon: "error",
                    title:
                      "Please enter a valid reference number from your receipt",
                  });
                } else if (result.value.amount && result.value.reference) {
                  this.$swal({
                    icon: "success",
                    title: "We will check your load asap. Thank you!",
                  });
                  let newTransactionKey = ref.child("load").push().key;
                  var newTransaction = {};
                  newTransaction[
                    "/load/" + this.currentUser.uid + "/" + newTransactionKey
                  ] = {
                    amount: result.value.amount,
                    id: this.currentUser.uid,
                    date: Date.now(),
                    referenceNo: result.value.reference,
                    status: "pending",
                  };
                  return ref.update(newTransaction);
                }
                this.$router.push("/");
              });
            }
          });
        } else {
          if (isValid) {
            let phoneNum;
            let slotsResults;
            if (!this.currentUser.phone) {
              this.$swal({
                title: "Get Alert on Phone Number",
                html: `We will notify you of your raffle ticket via SMS. <br><input type="number" id="phone" class="swal2-input" placeholder="09171234567">`,
                confirmButtonText: "Add Phone",
                focusConfirm: false,
                preConfirm: () => {
                  const phone = this.$swal
                    .getPopup()
                    .querySelector("#phone").value;
                  return { phone: phone };
                },
              }).then((result) => {
                if (result.value.phone.length < 11) {
                  this.$swal({
                    icon: "error",
                    title: "Please enter a valid Philippine cellphone number!",
                  });
                } else if (result.value.phone.length == 11) {
                  phoneNum = result.value.phone;
                  firebase
                    .database()
                    .ref("users/" + this.currentUser.uid + "/")
                    .update({
                      phone: result.value.phone,
                    });
                  for (var cart in this.cartItemList) {
                    var title = this.cartItemList[cart].title;

                    this.getSlots({
                      product: this.cartItemList[cart].id,
                      amount: this.cartItemList[cart].quantity,
                    }).then((res) => {
                      if (res) {
                        slotsResults = res.toString();
                        this.addSlots({
                          product: this.cartItemList[cart].id,
                          slots: res,
                          user: this.currentUser.uid,
                        });
                        this.saveToTransaction({
                          cartItemList: this.cartItemList[cart],
                          slots: res,
                          uid: this.currentUser.uid,
                        }).then(() => {
                          this.$swal({
                            title: "Success!",
                            text:
                              "Your transaction is successful. Your lucky numbers for " +
                              title +
                              " = " +
                              slotsResults,
                            icon: "success",
                            button: "OK",
                          }).then(() => {
                            let order_email =
                              "<html lang='en'> <head> <meta name=viewport' content='width=device-width, initial-scale=1.0'> <link href='https://fonts.googleapis.com/css?family=NTR' rel='stylesheet'> <link rel='stylesheet' href='https://fonts.googleapis.com/icon?family=Material+Icons'></head> <body> <div style='background-color: #6667ab;'><img style='width: 180px; padding-top: 15px; padding-left: 15px;' src='https://s3.ap-southeast-1.amazonaws.com/raffle.com.ph/raffle-cropped-white.png' /></div> '</center> <center> <h1 style='font-family: 'NTR'; color: #6667ab;'>Order confirmed!</h1> <img style='width: 400px;' src='https://media2.giphy.com/media/l3UcjBJUov1gCRGbS/giphy.gif' /> <div style='font-family: 'NTR'; color: #29282d; width: 430px; margin-top: 1rem;'> <p>Your order has been confirmed. Good luck!</p> <div style='padding: 10px;'><a style='text-decoration: none; background-color: #6667ab; padding: 10px 20px; color: white; border-radius: 10px;' href='https: //www.raffle.com.ph' target='_blank' rel='noopener'>Start Joining</a></div> </div> <center></center> </center> </div> <div style='width: 100%; color: #26bca2; font-family: 'Merriweather Sans'; font-size: 10px; padding-left: 2rem;'> <ul style='display: inline-block; list-style-type: none; margin: 0; padding: 0;'> <li style='float: left; padding: 20px;'><a style='color: #6667ab; text-decoration: none;' href='https: //www.raffle.com.ph' target='_blank' rel='noopener'><img style='width: 16px; height: auto; vertical-align: middle;' src='https://s3.ap-southeast-1.amazonaws.com/raffle.com.ph/web.png' /> www.raffle.com.ph</a></li> <li style='float: left; padding: 20px;'><a style='color: #6667ab; text-decoration: none;' href='https: //www.raffle.com.ph' target='_blank' rel='noopener'><img style='width: 16px; height: auto; vertical-align: middle;' src='https://s3.ap-southeast-1.amazonaws.com/raffle.com.ph/fb.png' /> /raffle.com.ph</a></li> <li style='float: left; padding: 20px;'><a style='color: #6667ab; text-decoration: none;' href='https: //www.raffle.com.ph' target='_blank' rel='noopener'><img style='width: 16px; height: auto; vertical-align: middle;' src='https://s3.ap-southeast-1.amazonaws.com/raffle.com.ph/ig.png' /> /raffle.com.ph</a></li> </ul> </div></div></html>";
                            var emaildata = JSON.stringify({
                              toAddresses: [this.currentUser.email],
                              textBody:
                                "Order Confirmed! Your lucky numbers for " +
                                title +
                                " are " +
                                slotsResults,
                              body: order_email,
                              subject:
                                "Order Confirmed! Your lucky numbers for " +
                                title +
                                " are " +
                                slotsResults,
                              sender: "raffle.com.ph <hello@raffle.com.ph>",
                            });
                            var config = {
                              method: "post",
                              url: "https://8xyy3wc7yl.execute-api.ap-southeast-1.amazonaws.com/dev/sendEmail",
                              headers: {
                                "Content-Type": "application/json",
                                "x-api-key":
                                  "be6V79mCxmwhJhSobKWa55l820J4oBX5Rd4aRMi9",
                              },
                              data: emaildata,
                            };
                            axios(config)
                              .then(function (response) {
                                console.log(JSON.stringify(response.data));
                              })
                              .catch(function (error) {
                                console.log(error);
                              });
                            var data = JSON.stringify({
                              recipient: phoneNum,
                              body:
                                "Your lucky numbers for " +
                                title +
                                " are " +
                                slotsResults,
                            });
                            var config2 = {
                              method: "post",
                              url: "https://api.raffle.com.ph/sendsms",
                              headers: {
                                "Content-Type": "application/json",
                              },
                              data: data,
                            };
                            axios(config2)
                              .then(function (response) {
                                console.log(JSON.stringify(response.data));
                              })
                              .catch(function (error) {
                                console.log(error);
                              });
                          });
                        });
                        this.updateCredit({
                          credits: this.currentUser.credits - this.cartValue,
                          user: this.currentUser.uid,
                        });
                        this.clearCart();
                        this.$router.push("/");
                      }
                    });
                  }
                }
              });
            } else {
              phoneNum = this.currentUser.phone;
              firebase
                .database()
                .ref("users/" + this.currentUser.uid + "/")
                .update({
                  phone: phoneNum,
                });
              let productId;

              for (var cart in this.cartItemList) {
                var title = this.cartItemList[cart].title;

                var product = this.cartItemList[cart];

                productId = this.cartItemList[cart].id;
                this.getSlots({
                  product: this.cartItemList[cart].id,
                  amount: this.cartItemList[cart].quantity,
                }).then((res) => {
                  if (res) {
                    slotsResults = res.toString();
                    this.addSlots({
                      product: productId,
                      slots: res,
                      user: this.currentUser.uid,
                    }).then((res) => {
                      if (res) {
                        this.saveToTransaction({
                          cartItem: product,
                          slots: res,
                          uid: this.currentUser.uid,
                        }).then(() => {
                          this.$swal({
                            title: "Success!",
                            text:
                              "Your transaction is successful. Your lucky numbers for " +
                              title +
                              " = " +
                              slotsResults,
                            icon: "success",
                            button: "OK",
                          }).then(() => {
                            let order_email =
                              "<html lang='en'> <head> <meta name=viewport' content='width=device-width, initial-scale=1.0'> <link href='https://fonts.googleapis.com/css?family=NTR' rel='stylesheet'> <link rel='stylesheet' href='https://fonts.googleapis.com/icon?family=Material+Icons'></head> <body> <div style='background-color: #6667ab;'><img style='width: 180px; padding-top: 15px; padding-left: 15px;' src='https://s3.ap-southeast-1.amazonaws.com/raffle.com.ph/raffle-cropped-white.png' /></div> '</center> <center> <h1 style='font-family: 'NTR'; color: #6667ab;'>Order confirmed!</h1> <img style='width: 400px;' src='https://media2.giphy.com/media/l3UcjBJUov1gCRGbS/giphy.gif' /> <div style='font-family: 'NTR'; color: #29282d; width: 430px; margin-top: 1rem;'> <p>Your order has been confirmed. Good luck!</p> <div style='padding: 10px;'><a style='text-decoration: none; background-color: #6667ab; padding: 10px 20px; color: white; border-radius: 10px;' href='https: //www.raffle.com.ph' target='_blank' rel='noopener'>Start Joining</a></div> </div> <center></center> </center> <center></div> <div style='width: 100%; color: #26bca2; font-family: 'Merriweather Sans'; font-size: 10px; padding-left: 2rem;'> <ul style='display: inline-block; list-style-type: none; margin: 0; padding: 0;'> <li style='float: left; padding: 20px;'><a style='color: #6667ab; text-decoration: none;' href='https: //www.raffle.com.ph' target='_blank' rel='noopener'><img style='width: 16px; height: auto; vertical-align: middle;' src='https://s3.ap-southeast-1.amazonaws.com/raffle.com.ph/web.png' /> www.raffle.com.ph</a></li> <li style='float: left; padding: 20px;'><a style='color: #6667ab; text-decoration: none;' href='https: //www.raffle.com.ph' target='_blank' rel='noopener'><img style='width: 16px; height: auto; vertical-align: middle;' src='https://s3.ap-southeast-1.amazonaws.com/raffle.com.ph/fb.png' /> /raffle.com.ph</a></li> <li style='float: left; padding: 20px;'><a style='color: #6667ab; text-decoration: none;' href='https: //www.raffle.com.ph' target='_blank' rel='noopener'><img style='width: 16px; height: auto; vertical-align: middle;' src='https://s3.ap-southeast-1.amazonaws.com/raffle.com.ph/ig.png' /> /raffle.com.ph</a></li> </ul> </div></div></center></html>";
                            var emaildata = JSON.stringify({
                              toAddresses: [this.currentUser.email],
                              textBody:
                                "Order Confirmed! Your lucky numbers for " +
                                title +
                                " are " +
                                slotsResults,
                              body: order_email,
                              subject:
                                "Order Confirmed! Your lucky numbers for " +
                                title +
                                " are " +
                                slotsResults,
                              sender: "raffle.com.ph <hello@raffle.com.ph>",
                            });
                            var config = {
                              method: "post",
                              url: "https://8xyy3wc7yl.execute-api.ap-southeast-1.amazonaws.com/dev/sendEmail",
                              headers: {
                                "Content-Type": "application/json",
                                "x-api-key":
                                  "be6V79mCxmwhJhSobKWa55l820J4oBX5Rd4aRMi9",
                              },
                              data: emaildata,
                            };
                            axios(config)
                              .then(function (response) {
                                console.log(JSON.stringify(response.data));
                              })
                              .catch(function (error) {
                                console.log(error);
                              });
                            "Order Confirmed! Your lucky numbers are " +
                              slotsResults;
                            var data = JSON.stringify({
                              recipient: phoneNum,
                              body:
                                "Your lucky numbers for " +
                                title +
                                " are " +
                                slotsResults,
                            });
                            var config2 = {
                              method: "post",
                              url: "https://api.raffle.com.ph/sendsms",
                              headers: {
                                "Content-Type": "application/json",
                              },
                              data: data,
                            };
                            axios(config2)
                              .then(function (response) {
                                console.log(JSON.stringify(response.data));
                              })
                              .catch(function (error) {
                                console.log(error);
                              });
                          });
                        });
                      }
                    });
                  }
                });
              }
              this.updateCredit({
                credits: this.currentUser.credits - this.cartValue,
                user: this.currentUser.uid,
              });
              this.clearCart();
              this.$router.push("/");
            }
          } else {
            this.addMessage({
              messageClass: "danger",
              message: message,
            });
          }
        }
      } else {
        this.$swal({
          title: "Please login to checkout",
          text: "You will be redirected to login page",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, login now!",
        }).then((result) => {
          if (result.value) {
            this.$router.push("/login");
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list-shopping-cart-leave-active {
  transition: all 0.4s;
}

.list-shopping-cart-leave-to {
  opacity: 0;
  transform: translateX(50px);
}

.table-sm {
  font-size: 0.875rem;
  ::v-deep h4 {
    font-size: 1.25rem;
  }
}
</style>
